export class SquirrelTabs {
  title!: string;
  route!: string;
  role?:string;
}

export const USERTABS: SquirrelTabs[] = [
  { title: 'TABUSERINFO', route: 'info' },
  { title: 'TABPLATFORMGROUPROLE&PERMISSIONS', route: 'roles-permissions' },
  { title: 'TABTENANTINFO', route: 'tenant-info' },
  { title: 'TABCHANGEUSERPASSWORD', route: 'change-password' }
];

export const PROJECTTABS: SquirrelTabs[] = [
  { title: 'TABPROJECTINFO', route: 'project-info' },
  { title: 'TABPROJECTGROUPROLE', route: 'project-role' },
  { title: 'TABPROJECTUSERS', route: 'project-user' }
];


export const TENANTTABS: SquirrelTabs[] = [
  { title: 'TABTENANTINFO', route: 'info' },
  { title: 'USERS', route: 'tenant-users' },
  { title: 'PROJECTS', route: 'tenant-projects' },
  // { title: 'TENANTGROUPROLE', route: 'tenant-grouproles' },
  { title: 'TENANTGROUP', route: 'tenant-groups' },
  //{ title: 'SUBTENANTS', route: 'sub-tenants' }
];

